import React from "react";
import { useTranslation } from "react-i18next";

import Carousel from "../../shared/components/Carousel";

import { studentsData } from "./utils/studentsData";

import classes from "./index.module.css";

const Students = () => {
  const { t } = useTranslation();

  return (
    <div id="students" className={classes["wrapper"]}>
      <p className={classes["title"]}>{t("Our students")}</p>
      <Carousel data={studentsData} />
    </div>
  );
};

export default Students;
